import { DOMParser } from '@xmldom/xmldom';

export class FeedParser {
  static cleanText(text) {
    if (!text) return '';
    text = text.replace(/<!\[CDATA\[(.*?)\]\]>/gs, '$1');
    text = text.replace(/<[^>]+>/g, '');
    return text.trim();
  }

  static getRandomImage(feed) {
    return feed.defaultImages[Math.floor(Math.random() * feed.defaultImages.length)];
  }

  static formatDate(dateStr) {
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return new Date().toLocaleDateString();
    }
  }

  static parseFeed(xml, feed) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, 'text/xml');
    
    if (doc.getElementsByTagName('parsererror').length > 0) {
      throw new Error('XML parsing error');
    }

    const items = Array.from(doc.getElementsByTagName('item'));
    const entries = Array.from(doc.getElementsByTagName('entry'));
    const allItems = [...items, ...entries];

    return allItems
      .map(item => {
        try {
          const title = this.cleanText(item.getElementsByTagName('title')[0]?.textContent);
          const description = this.cleanText(
            item.getElementsByTagName('description')[0]?.textContent ||
            item.getElementsByTagName('summary')[0]?.textContent
          );
          const link = item.getElementsByTagName('link')[0]?.textContent?.trim();
          const pubDate = item.getElementsByTagName('pubDate')[0]?.textContent ||
                         item.getElementsByTagName('published')[0]?.textContent;

          if (!title || !link || !pubDate) return null;

          return {
            title,
            description: description?.substring(0, 200) + '...',
            link,
            date: this.formatDate(pubDate),
            source: feed.name,
            imageUrl: this.getRandomImage(feed),
            category: feed.category
          };
        } catch (error) {
          console.error('Error parsing feed item:', error);
          return null;
        }
      })
      .filter(item => item !== null);
  }
}